export default "__VITE_ASSET__jnrNxLZz__"